export const LINKED_PROJECT_PREFIX = 'project-link-';

